
import ServiciosDeSSOUsuario from 'servicios/ServiciosDeSSOUsuario';
import { solicitud_de_sso } from 'servicios/Api';
import { NOMBRE_DE_SISTEMA } from '../constantes';

export default class User extends ServiciosDeSSOUsuario{
    constructor(){
        super("user");
    }

    view(){
        return this.obtenerRegistrosConParametros("view");
    }

    getUserMenu() {
        return this.obtenerRegistrosConParametros("menu/"+NOMBRE_DE_SISTEMA);
    }

    getCurrentUser(){
        return this.obtenerRegistrosConParametros("me");
    }

    cancelUser(data){
        return this.actualizarRegistro("/cancel/"+data.id);
    }

    hasPermission(form, action) {
        return this.nuevoRegistro("haspermission",{form, action})
    }

    changePassword(updateElement){ 
        return this.patchPersonalizado("changePassword", updateElement)
    }        

    login(loginRequest) {
        return solicitud_de_sso({
            url: "/auth/login",
            method: 'POST',
            body: JSON.stringify(loginRequest)
        });
    }
    
    signup(signupRequest) {
        return solicitud_de_sso({
            url: "/auth/signup",
            method: 'POST',
            body: JSON.stringify(signupRequest)
        });
    }

    signupFinalUser(signupRequest){
        return solicitud_de_sso({
            url: "/auth/signupFinalUser",
            method: 'POST',
            body: JSON.stringify(signupRequest)
        });
    }
     
}